import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-question-cta',
  standalone: true, imports: [RouterLink, RouterLinkActive, ScrollToModule],
  templateUrl: './question-cta.component.html',
  styleUrl: './question-cta.component.scss'
})
export class QuestionCtaComponent {

}
